import { useMutation } from 'react-query';
import { NetworkManager } from '../services';
import { SipFrequency } from './useValidateSipSubscription';
import { SipSourceType } from './useValidateSipSubscription';

export type ValidateEditSubscriptionPayload = {
  userId: number;
  recurringAmount: number;
  startDate: string;
  phone: string;
  subscriptionFrequency: SipFrequency;
  sourceType: SipSourceType;
  firstChargeDate: string;
  subscriptionId: string;
  frequencyNote?: string;
};

export const validateEditSubscription = async (
  subscriptionId: string,
  payload: ValidateEditSubscriptionPayload,
) => {
  const response = await NetworkManager.Call({
    method: 'post',
    path: NetworkManager.PATH.validateEditSipSubscription.replace(
      '{{subscriptionId}}',
      subscriptionId,
    ),
    data: payload,
  });
  return response.data;
};

export default function useValidateEditSubscription() {
  const mutation = useMutation(
    ({
      subscriptionId,
      payload,
    }: {
      subscriptionId: string;
      payload: ValidateEditSubscriptionPayload;
    }) => validateEditSubscription(subscriptionId, payload),
  );
  return {
    validateEditSubscription: mutation.mutate,
    validateEditSubscriptionAsync: mutation.mutateAsync,
    data: mutation.data as any | undefined,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
    reset: mutation.reset,
  };
}
